import type { ReactNode } from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma „Heading“ of the account pages (60321:19138): DLZ/Heading/H2 title, 16 px (8 on phones)
 * above a DLZ/Body/M description in text/secondary.
 */
export function AccountHeading({
  title,
  description,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  className?: string;
}) {
  return (
    <header className={cn('flex flex-col gap-2 md:gap-4', className)}>
      <h1 className="dlz-h2 text-[#0F1012]">{title}</h1>
      {description ? <p className="dlz-body-m text-[#4F545C]">{description}</p> : null}
    </header>
  );
}
